<template>
  <div class="download">
    <div class="d_content" v-if="data.length > 0">
      <table>
        <thead>
          <tr>
            <td align="center" width="100px">{{$t('序号')}}</td>
            <td align="center">{{$t('信息')}}</td>
            <td align="center" width="150px">{{$t('操作')}}</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td align="center">{{ index + 1 }}</td>
            <td align="center">{{ item.content }}</td>
            <td align="center" width="150px"><a-button type="primary" icon="download" @click="download(item)">{{$t('下载')}}</a-button></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="empty" v-else>
      <img src="../../../assets/db_logo.png"/>
      <p>{{$t('暂未上传数据')}}</p>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      loading: false,
      data: [],
      programId: this.$route.query.programId
    }
  },
  mounted () {
    this.listDownload()
  },
  methods: {
    listDownload () {
      this.loading = true
      this.$api.projectCenter.listDownload(this.programId).then(res => {
        if (res.status === 0) {
          this.data = res.data
        } else {
          this.$message.error(res.msg)
        }
      }).finally(_ => {
        this.loading = false
      })
    },
    download (record) {
      this.loading = true
      this.$api.projectCenter.downloadFile(this.programId, record.id).then(res => {
        if (res.status === 0) {
          const filePath = res.data
          window.open(filePath, 'project_center')
        } else {
          this.$message.error(res.msg)
        }
      }).finally(_ => {
        this.loading = false
      })
    }
  }
}
</script>
<style scoped lang="scss">
  .download {
    background: #eaeaea;

    .d_content {
      width: 1200px;
      margin: auto;
      padding-top: 60px;
      padding-bottom: 60px;
      table {
        width: 100%;
        thead {
          height: 60px;
          background: #7f7f7f;
          color: white;
          td {
            border-right: 1px solid white;
            font-size: 18px;
          }
        }
        tbody {
          tr {
            height: 70px;
            border: 1px solid #ffffff;
            td {
              border-right: 1px solid #ffffff;
              font-size: 16px;
            }
          }
        }
      }
    }
    .empty {
      padding-top: 60px;
      padding-bottom: 60px;
      width: 1200px;
      margin: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        height: 147px;
        width: 147px;
      }
      p {
        font-weight: 600;
        color: #838080;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/product/components/CenterDownload.vue